import React, { useContext } from 'react';
import styled from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useTags from '@ubeya/shared/hooks/account/useTags';
import TagsBadges from 'scheduling/components/ListView/TagsBadges';

const Wrapper = styled.div`
  display: flex;
  margin-top: 4px;
  min-width: 0;
`;

const TooltipTitle = styled.div`
  font-weight: 500;
`;

const TooltipNote = styled.div`
  max-width: 240px;
  font-size: 12rem;
  opacity: 0.7;
`;

const ShiftTagsBadges = ({ shiftTags = [], eventTags = [], eventName }) => {
  const { t } = useContext(ConfigContext);
  const { mappedTags } = useTags();

  const isInherited = !shiftTags?.length;
  const tags = (isInherited ? eventTags : shiftTags).filter((tagId) => mappedTags[tagId]);

  if (!tags.length) {
    return null;
  }

  const getLabel = ([firstTag]) => {
    if (tags.length > 1) {
      return t(isInherited ? 'eventTagsCount' : 'shiftTagsCount', { value: tags.length });
    }

    return isInherited ? t('eventTagLabel', { label: mappedTags[firstTag].label }) : mappedTags[firstTag].label;
  };

  return (
    <Wrapper>
      <TagsBadges
        tags={tags}
        getLabel={getLabel}
        tooltipHeader={<TooltipTitle>{isInherited ? t('eventTags') : t('shiftTags')}</TooltipTitle>}
        tooltipFooter={isInherited && <TooltipNote>{t('inheritedFromEventTooltip', { name: eventName })}</TooltipNote>}
      />
    </Wrapper>
  );
};

export default ShiftTagsBadges;
